<div class="st-notes-list-sidecar__header">
    <span class="st-notes-list-sidecar__header-label">{{ notesLabel() }}</span>
    <div class="st-notes-list-sidecar__header-btn-group">
        <button
            class="st-notes-list-sidecar__header-btn-group__note-btn"
            mat-stroked-button
            (click)="createNote()">
            <mat-icon
                small
                class="material-symbols-outlined">
                add
            </mat-icon>
            {{ i18n.PSTWebNoteLabel }}
        </button>
        <button
            mat-stroked-button
            class="st-notes-list-sidecar__header-btn-group__template-btn"
            [matMenuTriggerFor]="noteTemplateMenu"
            (menuOpened)="onNoteTemplateMenuOpened()">
            <mat-icon>arrow_drop_down</mat-icon>
        </button>
    </div>
</div>
<div class="st-notes-list-sidecar__search-expand-bar">
    <st-simple-search-box-autocomplete
        st-click-stop-propagation
        class="st-notes-list-sidecar__search-expand-bar__search-bar"
        (searchExecute)="onQueryTermChange($event)" />
    <button
        mat-icon-button
        (click)="toggleExpandAllNotes()">
        <mat-icon fontSet="material-symbols-outlined">{{ expandNotesIcon() }}</mat-icon>
    </button>
</div>
<div class="st-notes-list-sidecar__filter-bar">
    @for (filter of notesFilters().Filters; track filter.ID) {
        @switch (filter.Type) {
            @case (filter.Type === 'checklist' || filter.Type === 'combobox' ? filter.Type : null) {
                <st-check-list
                    [tabindex]="$index"
                    [value]="filter.Value"
                    [label]="filter.DefaultCaption"
                    [itemList]="filter.Options"
                    (changed)="onFilterChange()"
                    (selectionChange)="onSelectionChange($event, $index, filter)" />
            }
        }
    }
    <button
        #sortMenuTrigger="matMenuTrigger"
        mat-stroked-button
        class="st-notes-list-sidecar__filter-bar__sort-btn"
        [matMenuTriggerFor]="sortMenu">
        <span class="st-notes-list-sidecar__filter-bar__sort-btn__content">
            {{ sortBtnLabel() }}
            <mat-icon>{{ sortMenuTrigger.menuOpen ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
        </span>
    </button>
</div>

@if (notes()?.length === 0) {
    <div class="st-notes-list-sidecar-text">
        {{ 'Sorry, there are no results matching your criteria' }}
    </div>
} @else {
    <cdk-virtual-scroll-viewport
        maxBufferPx="0"
        minBufferPx="0"
        class="st-notes-list-sidecar-viewport"
        st-different-sizes
        [itemHeights]="noteHeights()">
        <st-note-item
            *cdkVirtualFor="let node of treeDataSource(); last as isLast; trackBy: trackByGuid; templateCacheSize: 0"
            [expanded]="treeControl().isExpanded(node)"
            [note]="node.object"
            [disabled]="disabled()"
            [searchTerm]="searchTerm()"
            (itemClicked)="noteClicked(node.object.Guid)" />
    </cdk-virtual-scroll-viewport>
}

<mat-menu
    #sortMenu="matMenu"
    class="st-notes-list-sidecar__menu"
    xPosition="before">
    <ng-template matMenuContent>
        <mat-selection-list
            hideSingleSelectionIndicator
            multiple="false"
            (selectionChange)="onSortChange($event.options[0].value)">
            @for (sort of noteSortOptions(); track $index) {
                <mat-list-option
                    [selected]="selectedSortId() === `${sort.metadata.sortBy}${sort.metadata.sortOrder}`"
                    [value]="sort">
                    {{ sort.label }}
                    @if (selectedSortId() === `${sort.metadata.sortBy}${sort.metadata.sortOrder}`) {
                        <mat-icon>check</mat-icon>
                    }
                </mat-list-option>
            }
        </mat-selection-list>
    </ng-template>
</mat-menu>

<mat-menu
    #noteTemplateMenu="matMenu"
    class="st-notes-list-sidecar-templates-menu">
    @if (noteTemplates().length > 0) {
        <ng-template matMenuContent>
            @for (item of noteTemplates(); track item?.Guid) {
                <mat-selection-list
                    hideSingleSelectionIndicator
                    [multiple]="false">
                    <mat-list-option
                        st-click-stop-propagation
                        class="st-notes-list-sidecar-button-new-note-template"
                        [value]="item?.Title"
                        [disabled]="item?.isDeleted"
                        (click)="selectNoteTemplate(item)">
                        <div
                            matListItemTitle
                            class="st-notes-list-sidecar-button-new-note-template__title"
                            [dir]="directionality()">
                            <span>{{ item?.noteBeginText || item?.RawContent }}</span>
                            <button
                                mat-icon-button
                                matListItemMeta
                                st-click-stop-propagation
                                [disabled]="item?.isDeleted"
                                (click)="deleteTemplate(item)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </mat-list-option>
                </mat-selection-list>
            }
        </ng-template>
    }
</mat-menu>
